import base from "@/store/utils/api-route/base";
const transaksi_masal = `${base.masterData}transaksi_masal/`
const api = {
    getListInvoice: `${base.masterData}transaksi_masal/list_invoice`,
    getListKonsumen: `${base.masterData}transaksi_masal/list_konsumen_detail`,
    getDetailInvoice: `${base.masterData}transaksi_masal/detail_invoice`,
    getDetailTagihan: `${base.masterData}transaksi_masal/list_transaksi_detail`,
    getListTransaksi: `${base.masterData}transaksi_masal/list_transaksi`,

    sendWaInvoice: `${base.masterData}transaksi_masal/send_wa_invoice`,
    createInvoice: `${base.masterData}transaksi_masal/create_invoice`,
    cancelInvoice: `${base.masterData}transaksi_masal/pembatalan_invoice_sebelum_bayar`,
    cancelInvoiceLunas: `${base.masterData}transaksi_masal/refund_invoice`,
    deleteInvoice: `${base.masterData}transaksi_masal/delete_invoice`,
    pembayaranInvoice: `${base.masterData}transaksi_masal/pembayaran_invoice`,
    getDataModal:`${base.masterData}transaksi_masal/meta_modal_konfirmasi_ambil_layanan/`,
    getDataInvoiceWASender: `${base.masterData}transaksi_masal/cek_send_by?idoutlet=`,
    getMcoinInfo: `${base.masterData}global/constant?key=KOIN_INVOICE_SCHEDULE`,
    export: {
        job: `${base.export}job`,
        track: `${base.export}track_redis_job`,
        delete: {
            cluster: `${base.export}delete_cluster_redis_job`,
            master: `${base.export}delete_master_redis_job`,
        },
    },
    penjadwalan: {
        index: `${transaksi_masal}penjadwalan/`, 
        listKonsumenSchedule: `${base.masterData}transaksi_masal/penjadwalan/list_customer?search=`,
        createPenjadwalan: `${transaksi_masal}penjadwalan/`,
        delete: `${transaksi_masal}penjadwalan/`,
        detail: `${transaksi_masal}penjadwalan/detail`,
        update: `${transaksi_masal}penjadwalan/update`,
    },
    coupon: {
        index: `${transaksi_masal}coupon?fitur=`, 
        coupon_validaton: `${transaksi_masal}coupon_validation`, 
        cron_coupon_claim: `${transaksi_masal}/penjadwalan/cron_coupon_claim`,
        mcoin_estimation: `${transaksi_masal}penjadwalan/get_coin_usage_estimation`,
    }
};

export default api;
